import React from 'react'
import { Box, ButtonPrimaryWithArrow, Typography } from '@creditas-ui/react'
import { ModalBanner } from 'shared/ui/ModalBanner/ModalBanner'
import { NotificationIds } from 'notifications/domain/NotificationsIds'
import { ContainerImage } from './HomeFinancingIndication.styles'
import { Routes } from 'config/routes'

const HomeFinancingIndication = ({ isOpen, closeModal, goTo }) => (
  <ModalBanner
    isOpen={isOpen.indication}
    closeModal={() => closeModal(NotificationIds.HomeFinancingIndication)}
    title="O portal Creditas está ainda mais completo 🤩"
  >
    <Box display="flex" justifyContent="space-between" spaceX="10px">
      <Box width="50%" pt="18px">
        <ContainerImage />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        width="50%"
        pr="49px"
        pt="47px"
      >
        <Box
          bg="neutral.0"
          borderRadius="16px"
          width="159px"
          textAlign="center"
        >
          <Typography
            color="neutral.80"
            variant="bodyXsRegular"
            p="3px 8px 3px 8px"
          >
            Financiamento de Imóvel
          </Typography>
        </Box>
        <Typography variant="bodyLgRegular" pt="24px" color="neutral.100">
          Amplie seu leque de produtos e surpreenda seus clientes:
        </Typography>
        <Typography
          variant="bodySmLight"
          pt="16px"
          pb="40px"
          color="neutral.90"
        >
          Envie sua proposta de financiamento imobiliário para análise de
          crédito nos principais bancos agora mesmo direto pelo portal.
        </Typography>
        <ButtonPrimaryWithArrow
          data-testid="indication-button"
          onClick={() => goTo(Routes.LeadForm.HomeFinancing)}
        >
          Faça uma indicação
        </ButtonPrimaryWithArrow>
      </Box>
    </Box>
  </ModalBanner>
)

export { HomeFinancingIndication }
